module.exports = __webpack_public_path__ + "img/pro_detail_4.7143737c.jpg";